import { User } from "../types"

export const jamUserLocalStorageKey = "jamUser"

export const updateLocalUser = (patch: Partial<User>) => {
	try {
		const currentSavedUser = localStorage.getItem(jamUserLocalStorageKey)
		if (!currentSavedUser) {
			return
		}
		const newUser = { ...JSON.parse(currentSavedUser), ...patch }
		localStorage.setItem(jamUserLocalStorageKey, JSON.stringify(newUser))
	} catch {
		// fail silenty BUT YOU SHOULD LOG THIS TO SENTRY
	}
}
